import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { getProductCollectionRealTimePrices } from "@WhiteCap/Services/ProductGroupingLoadProductService";
import { choiceOfFreeProducts } from "@WhiteCap/Store/Service/PromotionProductServices";
import { CustomApiHandler } from "@WhiteCapInternal/Store/CustomHandlerCreator/CustomHandlerCreator";

type Parameter = {
    promotionId: string;
    promotionDetail?: {
        type: string;
        amount: number;
    };
};

type Props = {
    products: ProductModel[];
};

type HandlerType = CustomApiHandler<Parameter, Props>;

export const PromotionBeingLoaded: HandlerType = props => {
    props.dispatch({
        type: "Custom/Promotion/BeginLoadProducts",
    });
};

export const PromotionBeginPromotionId: HandlerType = props => {
    props.dispatch({
        type: "Custom/Promotion/BeginPromotionId",
        promotionId: props.parameter.promotionId,
    });
};

export const PromotionLoadAPI: HandlerType = async props => {
    const products = await choiceOfFreeProducts({
        promotionId: props.parameter.promotionId,
    });

    props.apiResult = { products: products as unknown as ProductModel[] };
};

export const PromotionGetRealTimePricing: HandlerType = async props => {
    if (!props.parameter.promotionDetail) {
        props.apiResult.products.forEach(product => {
            product.cantBuy = false;
        });
        return;
    }
    const PRICE_THRESHOLD = props.parameter.promotionDetail.amount;
    const state = props.getState();
    const session = getSession(state);
    if (!session.isAuthenticated) {
        return;
    }

    const productPriceParameters = props.apiResult.products.map((product: ProductModel) => {
        return {
            productDetailPath: ``,
            productId: product.id,
            qtyOrdered: 1,
            unitOfMeasure: "",
        };
    });
    const pricing = await getProductCollectionRealTimePrices(productPriceParameters);

    const prices = pricing.realTimePricingResults;
    if (!prices) return;
    props.apiResult.products.forEach(product => {
        const priceInfo = prices.find(price => price.productId === product.id);
        product.unitListPriceDisplay = priceInfo?.actualPriceDisplay ?  priceInfo.actualPriceDisplay : "0";
        if (priceInfo && priceInfo.actualPrice > PRICE_THRESHOLD) {
            product.cantBuy = true;
        } else {
            product.cantBuy = false;
        }
    });
};

export const PromotionLoadedCompleted: HandlerType = async props => {
    props.dispatch({
        type: "Custom/Promotion/CompletedLoadProducts",
        products: props.apiResult?.products,
    });
};

export const PromotionEndedLoaded: HandlerType = props => {
    props.dispatch({
        type: "Custom/Promotion/BeginEndedProducts",
    });
};

export const chain = [
    PromotionBeingLoaded,
    PromotionBeginPromotionId,
    PromotionLoadAPI,
    PromotionGetRealTimePricing,
    PromotionLoadedCompleted,
    PromotionEndedLoaded,
];

const promotionHandler = createHandlerChainRunner(chain, "PromotionHandler");
export default promotionHandler;
